import { EnrolmentNotEnrolledReason } from '@studyportals/sp-lord-business-interface';
import { ValidationResult } from '../../../validation/validation-result';
import { TriggerPayload } from '../trigger-payload';
import { ReviewReasonValidation } from './review-reason-validation';
import { TriggerPayloadValidation } from './trigger-payload-validation';

const NOT_ENROLLED_REVIEW_REASONS = Object.values(EnrolmentNotEnrolledReason);

export class EnrolmentNotRecognizedPayloadValidation extends TriggerPayloadValidation {
	public validateInExistingResult(payload: TriggerPayload, result: ValidationResult): ValidationResult {
		new ReviewReasonValidation(NOT_ENROLLED_REVIEW_REASONS).validateInExistingResult(payload, result);

		return result;
	}
}
